export var DirectoryEntityType;
(function (DirectoryEntityType) {
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_UNSPECIFIED"] = "DIRECTORY_ENTITY_TYPE_UNSPECIFIED";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_USER"] = "DIRECTORY_ENTITY_TYPE_USER";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_GROUP"] = "DIRECTORY_ENTITY_TYPE_GROUP";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_ORG_UNIT"] = "DIRECTORY_ENTITY_TYPE_ORG_UNIT";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_ROLE"] = "DIRECTORY_ENTITY_TYPE_ROLE";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_ROLE_ASSIGNMENT"] = "DIRECTORY_ENTITY_TYPE_ROLE_ASSIGNMENT";
    DirectoryEntityType["DIRECTORY_ENTITY_TYPE_LICENSE"] = "DIRECTORY_ENTITY_TYPE_LICENSE";
})(DirectoryEntityType || (DirectoryEntityType = {}));
